import React from "react";
import "./browserStats.css";

const browserStats = [
  { name: "GoogleChrome", percentage: 85, color: "#4caf50" },
  { name: "Firefox", percentage: 35, color: "#e65100" },
  { name: "Internet Explorer", percentage: 78, color: "#f44336" },
  { name: "Safari", percentage: 50, color: "#2196f3" },
  { name: "Opera", percentage: 80, color: "#9c27b0" },
  { name: "Others", percentage: 60, color: "#e65100" },
];

const BrowserStatsComponent = () => {
  return (
    <div className="browser-stats-box">
      <h3 className="chart-title">Browser Stats</h3>
      <div className="browser-stats-list">
        {browserStats.map((browser, index) => (
          <div key={index} className="browser-stat-item">
            <div className="browser-name-row">
              <span className="browser-name">{browser.name}</span>
              <span className="browser-percentage">{browser.percentage}%</span>
            </div>
            <div className="progress-bar-container">
              <div
                className="progress-bar"
                style={{
                  width: `${browser.percentage}%`,
                  backgroundColor: browser.color,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrowserStatsComponent;




